import { render, staticRenderFns } from "./AddOrEditLocation.vue?vue&type=template&id=80355f4c&scoped=true&"
import script from "./AddOrEditLocation.vue?vue&type=script&lang=js&"
export * from "./AddOrEditLocation.vue?vue&type=script&lang=js&"
import style0 from "./AddOrEditLocation.vue?vue&type=style&index=0&id=80355f4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80355f4c",
  null
  
)

export default component.exports